
import { mode } from "@chakra-ui/theme-tools";

export const globalStyles = {
  colors: {
    gray: {
      700: "#1f2733",
    },
    navy: {
      50: "#d0dcfb",
      100: "#aac0fe",
      200: "#a3b9f8",
      300: "#728fea",
      400: "#3652ba",
      500: "#1b3bbb",
      600: "#24388a",
      700: "#1b254b",
      800: "#111c44",
      900: "#0b1437",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("gray.50", "#1B254B")(props),
        fontFamily: "Helvetica, sans-serif",
      },
      html: {
        fontFamily: "Helvetica, sans-serif",
      },
      "::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
      },
      "::-webkit-scrollbar-track": {
        background: mode("gray.100", "#0b1437")(props),
      },
      "::-webkit-scrollbar-thumb": {
        background: mode("gray.400", "#4a5568")(props),
        borderRadius: "8px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: mode("gray.500", "#718096")(props),
      },
      ".rdtPicker" : {
        bg: mode("white", "#1F2733")(props),
        color: mode("#1F2733", "white")(props),
        border: `1px solid ${mode("#CBD5E0", "#4a5568")(props)}`,
      }
    }),
  },
};
